import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";
import { LaIconEditorTab } from "^/Components/ScrivitoExtensions/LaIconEditorTab";
import redirectObjIcon from "../../assets/images/redirect_obj.svg";

Scrivito.provideEditingConfig("Redirect", {
  title: "Redirect",
  thumbnail: redirectObjIcon,
  hideInSelectionDialogs: false,
  attributes: localizeAttrList(["link", "title", "openInUi"], "Quote"),
  properties: ["title", "description", "shortDescription", "link", "openInUi"],
  propertiesGroups: [
    {
      title: "LA Icon",
      component: ({ obj }) => (
        <LaIconEditorTab obj={obj} attribute="navigationIcon" />
      ),
      key: "laIconEditorTab",
    },
  ],
  initialContent: {
    openInUi: "no",
  },
});
